<template>
    <div class="io-filterable" :class="{ 'd-none': typeOfHide !== 'remove' ? ! visible : false }" v-if="typeOfHide !== 'remove' ? true : visible">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'IoFilterable',

  props: {
    tag: {
      required: true,
    },
    typeOfHide: {
      required: false,
      default: 'remove',
    },
  },

  data() {
    return {
      visible: true,
    };
  },
};
</script>
